export const Divider = {
  Dot: 'DOT',
} as const
export type Divider = (typeof Divider)[keyof typeof Divider]
